import {
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { CircleCheckBigIcon } from "lucide-react";

interface SignUpSuccessProps {
	email?: string;
	name?: string;
	className?: string;
}

export default function SignUpSuccess({
	email,
	name,
	className,
}: SignUpSuccessProps) {
	return (
		<Card className={cn("bg-transparent border-none shadow-none", className)}>
			<CardHeader className="items-center justify-center text-center space-y-4">
				<CircleCheckBigIcon className="w-12 h-12 text-green-500" />
				<CardTitle className="text-3xl font-extrabold tracking-tighter">
					Thank you for signing up{name ? `, ${name}` : ""}.
				</CardTitle>
				<CardDescription>
					We have sent a confirmation email to{" "}
					<span className="font-semibold">{email}</span>.
				</CardDescription>
			</CardHeader>
			<CardContent>
				<p className="text-md text-primary text-center">
					You&apos;ve successfully signed up.
					<br />
					Please check your email to confirm your account.
				</p>
			</CardContent>
		</Card>
	);
}
